/**
 *  components 通用全局组件
 */
import Vue from 'vue'

import SubPage from "@/components/Subpage";
import StuPage from "@components/Stupage";
import UIPanel from "@components/UIPanel";
import SelectMultiKnowledge from "@components/SelectMultiKnowledge";
import SelectMultiOrgs from "@components/SelectMultiOrgs";
import SelectMultiple from "@components/Selectmultiple";
import SelectSingleOrg from "@components/SelectSingleOrg";
import TypeTag from "@components/UI/TypeTag";
import TipLabel from "@components/UI/TipLabel";

Vue.component('SubPage', SubPage)
Vue.component('StuPage', StuPage)
Vue.component('UiPanel', UIPanel)
Vue.component('SelectMultiKnowledge', SelectMultiKnowledge)
Vue.component('SelectMultiOrgs', SelectMultiOrgs)
Vue.component('SelectMultiple', SelectMultiple)
Vue.component('SelectSingleOrg', SelectSingleOrg)
Vue.component('TypeTag', TypeTag)
Vue.component('TipLabel', TipLabel)
